import IconButton from '@material-ui/core/IconButton';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

import css from '../nibTable.module.sass';
import Add from './Add';

const THeader = ({ headerGroups, isAdd, setAdd, generateAddRow, onNewSave, addItem, readOnly, disableAddButton }) => {
  return (
    <thead>
      {headerGroups.map((headerGroup) => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          {!readOnly && (
            <th colSpan="2" className={css.add}>
              <Add disableAddButton={disableAddButton} onClick={addItem} />
            </th>
          )}
          {headerGroup.headers.map((column) => (
            <th {...column.getHeaderProps(column.getSortByToggleProps())} {...column.props}>
              <span>
                {column.isSorted ? (
                  column.isSortedDesc ? (
                    <ArrowDropDownIcon />
                  ) : (
                    <ArrowDropUpIcon />
                  )
                ) : (
                  <ArrowDropUpIcon style={{ color: 'transparent' }} />
                )}
                {column.render('Header')}
              </span>
            </th>
          ))}
        </tr>
      ))}
      {isAdd && (
        <tr>
          <th className={css.edit}>
            <IconButton onClick={onNewSave}>
              <CheckIcon />
            </IconButton>
          </th>
          <th className={css.edit}>
            <IconButton onClick={() => setAdd(false)}>
              <CloseIcon />
            </IconButton>
          </th>
          {generateAddRow()}
        </tr>
      )}
    </thead>
  );
};

export default THeader;
